<template>
  <ResetPassword
    clientType="user"
    :form="form"
    :formEmail="formEmail"
    :isLoading="isLoading"
    :passwordPolicy="passwordPolicy"
    :submit="submit"
  />
</template>

<script>
// Components
import ResetPassword from 'client/components/forms/ResetPassword.vue';

// Services
import userResetPasswordService from 'client/services/userResetPasswordService';

export default {
  name: 'UserResetPasswordInputHandler',

  components: {
    ResetPassword,
  },

  props: {
    form: {
      type: Object,
      required: true,
    },
    // Explicit MFA-direct gate — do not infer from empty requestKey alone
    // (email activation form can also lack key).
    isMfaDirect: {
      type: Boolean,
      default: false,
    },
    pwdResetMfaVerified: {
      type: Boolean,
      default: false,
    },
    requestKey: {
      type: String,
      default: '',
    },
    formEmail: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isLoading: false,
      passwordPolicy: null,
    };
  },

  async created() {
    await this.loadPasswordPolicy();
  },

  watch: {
    requestKey() {
      this.loadPasswordPolicy();
    },
  },

  methods: {
    async loadPasswordPolicy() {
      this.passwordPolicy = await userResetPasswordService.getPasswordPolicy(
        this.requestKey,
      );
    },

    async submit() {
      this.isLoading = true;
      this.$emit('resetErrorMessage');
      // eslint-disable-next-line vue/no-mutating-props
      this.form.deviceCode = await userResetPasswordService.getDeviceCertCode();

      try {
        if (this.isMfaDirect || this.pwdResetMfaVerified) {
          await userResetPasswordService.resetPassword(
            this.requestKey,
            userResetPasswordService.passwordCommitFromForm(this.form),
          );
        } else {
          await userResetPasswordService.resetPassword(this.requestKey, this.form);
        }
        this.$emit('success');
      } catch (error) {
        this.$emit('error', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style module>
@import '../../../css/login-components.css';
</style>
